import { render, staticRenderFns } from "./BMDIDImport.vue?vue&type=template&id=73a1c4fd&scoped=true&"
import script from "./BMDIDImport.vue?vue&type=script&lang=js&"
export * from "./BMDIDImport.vue?vue&type=script&lang=js&"
import style0 from "./BMDIDImport.vue?vue&type=style&index=0&id=73a1c4fd&scoped=true&lang=css&"
import style1 from "./BMDIDImport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1c4fd",
  null
  
)

export default component.exports